import React, { useState } from 'react';
import ModalComponent from 'components/modal-component';
import { Currencies } from 'model/enums';
import { Col, FloatingLabel, Form, Row, Spinner } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import * as formik from 'formik';
import * as yup from 'yup';
import { generateschema } from 'validation-schema/enterprise-plan';
import { useGenerateEnterprisePaymentMutation } from 'api/enterprisePlanApi';
import { showToastError, showToastSuccess } from 'components/toastify/ToastNotifications';
import PhoneInput from 'react-phone-number-input';
import { ExternalResponse } from 'model/enterprise-plan-model';

type Props = {
    showModal: boolean;
    setShowModal: (value: boolean) => void;
}

const GeneratePayment = ({ showModal, setShowModal }: Props) => {
    const [loading, setLoading] = useState(false);
    const { Formik } = formik;
    const [phoneValidation, setPhoneValidation] = React.useState(false);
    const [phoneNumber, setPhoneNumber] = React.useState<any>();

    const [generatePaymentLink] = useGenerateEnterprisePaymentMutation();

    const handleSubmit = async (values: any) => {
        
        
        try {
            setLoading(true);
            const model = {
                companyEmail: values?.companyEmail,
                companyName: values?.companyName,
                amount: +values?.amount,
                frequency: values?.frequency,
                application: 'Joble',
                currency: values?.currency,
                phoneNumber: phoneNumber,
                personalEmail: values?.personalEmail,
                isExistingUser: true,
                EnterprizeFreePlan: false,
            }
            const result = await generatePaymentLink(model).unwrap();
            if (result?.ResponseCode == '200') {
                showToastSuccess(result?.ResponseMessage);
                setShowModal(false)
                setPhoneNumber('');
            }
            else {
                showToastSuccess(result?.ResponseMessage);
            }
        } catch (error: any) {
            const response = error.data as ExternalResponse<null>;
            showToastError(response?.ResponseMessage || '');
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <ModalComponent size={undefined} showModal={showModal} hideModal={() => setShowModal(false)}>
            <div className='p-3'>
                <div className='text-end'>
                    <button className='btn p-0'><AiOutlineClose onClick={() => setShowModal(false)} size={20} /></button>
                </div>
                <Formik
                    validationSchema={generateschema}
                    onSubmit={handleSubmit}
                    initialValues={{
                        companyName: '',
                        companyEmail: '',
                        amount: '',
                        frequency: '',
                        currency: '',
                        personalEmail: '',
                        application: 'Joble',
                        isExistingUser: true,
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
                        <Form noValidate onSubmit={handleSubmit} className='px-4'>
                            <h5 className='text-center'>Kindly fill in the form below to generate payment link</h5>
                            <div className='my-4'>
                                <Form.Group controlId="companyName">
                                    <FloatingLabel controlId="floatingSelect" label='Enter company name' className='float-input my-4'>
                                        <Form.Control type='text'
                                            name="companyName"
                                            value={values.companyName}
                                            onChange={handleChange}
                                            isValid={touched.companyName && !errors.companyName}
                                            isInvalid={touched.companyName && errors.companyName ? true : false}
                                            onBlur={handleBlur}
                                            placeholder='Enter company name' className={`border-0 w-100`}>
                                        </Form.Control>
                                    </FloatingLabel>
                                    {touched.companyName && errors.companyName && <Form.Control.Feedback type="invalid">{errors.companyName}</Form.Control.Feedback>}
                                </Form.Group>
                                <Form.Group controlId="companyEmail">
                                    <FloatingLabel controlId="floatingSelect" label='Enter company email' className='float-input my-4'>
                                        <Form.Control type='email'
                                            name="companyEmail"
                                            value={values.companyEmail}
                                            onChange={handleChange}
                                            isValid={touched.companyEmail && !errors.companyEmail}
                                            isInvalid={touched.companyEmail && errors.companyEmail ? true : false}
                                            onBlur={handleBlur}
                                            placeholder='Enter company email' className={`border-0 w-100`}>
                                        </Form.Control>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group controlId="amount">
                                    <FloatingLabel controlId="floatingSelect" label='Enter amount' className='float-input my-4'>
                                        <Form.Control type='number'
                                            name="amount"
                                            value={values.amount}
                                            onChange={handleChange}
                                            isValid={touched.amount && !errors.amount}
                                            isInvalid={touched.amount && errors.amount ? true : false}
                                            onBlur={handleBlur}
                                            placeholder='Enter amount' className={`border-0 w-100`}>
                                        </Form.Control>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group controlId="frequency">
                                    <FloatingLabel controlId="floatingSelect" label='Select frequency' className='float-input my-4'>
                                        <Form.Select
                                            name="frequency"
                                            value={values.frequency}
                                            onChange={handleChange}
                                            isValid={touched.frequency && !errors.frequency}
                                            isInvalid={touched.frequency && errors.frequency ? true : false}
                                            onBlur={handleBlur}
                                            className={`border-0 w-100`}>
                                            <option value="">Select an option</option>
                                            <option value="Yearly">Yearly</option>
                                            <option value="Monthly">Monthly</option>
                                        </Form.Select>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group controlId="personalEmail">
                                    <FloatingLabel controlId="floatingSelect" label='Enter personal email' className='float-input my-4'>
                                        <Form.Control
                                            name="personalEmail"
                                            placeholder='Enter personal email'
                                            value={values.personalEmail}
                                            onChange={handleChange}
                                            isValid={touched.personalEmail && !errors.personalEmail}
                                            isInvalid={touched.personalEmail && errors.personalEmail ? true : false}
                                            onBlur={handleBlur}
                                            className={`border-0 w-100`}>
                                        </Form.Control>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group controlId="phoneNumber" className='d-flex'>
                                    <PhoneInput
                                        placeholder='Enter admin phone number'
                                        international
                                        value={phoneNumber}
                                        defaultCountry="US"
                                        onChange={phone => setPhoneNumber(phone)}
                                        inputProps={{ name: 'phoneNumber', required: true }}
                                        countryCallingCodeEditable={false}
                                        className='d-flex justify-content-between w-100 my-3'
                                    />
                                    {/* {phoneNumber && <div className='text-end px-2 my-auto' style={{ marginLeft: '-40px' }}>{phoneValidation ? <BsCheckLg size={20} color='green' /> : <AiOutlineInfoCircle size={18} color='red' style={{ transform: 'rotate(180deg)' }} />}</div>} */}
                                </Form.Group>
                                <Form.Group controlId="currency">
                                    <FloatingLabel controlId="floatingSelect" label='Select a currency' className='float-input my-4'>
                                        <Form.Select
                                            name='currency'
                                            value={values.currency}
                                            onChange={handleChange}
                                            isValid={touched.currency && !errors.currency}
                                            isInvalid={touched.currency && errors.currency ? true : false}
                                            onBlur={handleBlur}
                                            className={`border-0 w-100`}>
                                            <option value="">Select an option</option>
                                            {Currencies?.map((list, key) => <option key={key} value={list}>{list}</option>)}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Form.Group>
                                {/* <Form.Group controlId="package">
                                    <FloatingLabel controlId="floatingSelect" label="Select a Package" className='float-input'>
                                        <Form.Select
                                            aria-label="Floating label select example"
                                            name='application'
                                            value={values.application}
                                            onChange={handleChange}
                                            isValid={touched.application && !errors.application}
                                            isInvalid={touched.application && errors.application ? true : false}
                                            onBlur={handleBlur}
                                            className="border-0 w-100">
                                            <option value=''>Choose a Package</option>
                                            <option value='Joble'>Joble</option>
                                            <option value='Echo'>Echo </option>
                                            <option value='JobPays'>JobPays</option>
                                            <option value='JobFy'>JobFy</option>
                                            <option value='JobID'>JobID</option>
                                            <option value='JobEvent'>JobEvent</option>
                                        </Form.Select>
                                    </FloatingLabel>
                                </Form.Group> */}
                            </div>
                            <div className='py-2'><button type='submit' className='btn-primary py-2 w-100'>Submit {loading && <Spinner size='sm' />} </button></div>
                        </Form>
                    )}
                </Formik>
            </div>
        </ModalComponent>
    )
}

export default GeneratePayment;
